import * as _ from 'lodash-es';
import moment from 'moment';
import type { Cutoff } from '../../utils/groupByCutoffs';

export default function historyCutoffs(): Cutoff[] {
  const momentLastYear = moment().subtract(1, 'year');

  return [
    {
      key: 'recent',
      label: null,
      cutoff: moment().startOf('month'),
    },
    ..._.rangeRight(moment().month()).map((month) => {
      const momentMonth = moment().month(month);

      return {
        key: month,
        label: momentMonth.format('MMMM'),
        cutoff: momentMonth.startOf('month'),
      };
    }),
    {
      key: 'last_year',
      label: momentLastYear.format('YYYY'),
      cutoff: momentLastYear.startOf('year'),
    },
    {
      key: 'older',
      label: 'Older',
    },
  ];
}
